import React, { useRef } from 'react';
import styled, { css } from 'styled-components';

import { ButtonPrimary } from '@/components/CarCard/components/Button';
import useHideElementIntersection from '@/hooks/useHideElementIntersection';
import { DetailedCarFixedPreviewPanelProps } from '@/components/DetailedCarFixedPreviewPanel/DetailedCarFixedPreviewPanel.types';
import CarPrice from '@/components/CarPrice';

function DetailedCarFixedPreviewPanel({
  title,
  price,
  onClick,
  buttonTitle,
}: DetailedCarFixedPreviewPanelProps) {
  const ref = useRef<HTMLDivElement>(null);
  const [isShowFixedPanel] = useHideElementIntersection({
    hiddenElement: ref,
    targetElement: '#bottom-footer',
    additionalOptions: {
      flag: true,
    },
  });
  return (
    <Component
      id="fixed-preview-car-panel"
      isShowFixedPanel={isShowFixedPanel}
      ref={ref}
    >
      <Title>{title}</Title>

      <PricesWrapper>
        <CarPrice {...price} isMobile />
      </PricesWrapper>

      {buttonTitle && (
        <StyledButton onClick={onClick}>{buttonTitle}</StyledButton>
      )}
    </Component>
  );
}

export default DetailedCarFixedPreviewPanel;

const StyledButton = styled(ButtonPrimary)`
  margin-top: 13px;
  padding-top: 8px;
  padding-bottom: 8px;
  font-size: 14px;
  line-height: 16px;
`;

const PricesWrapper = styled.div`
  margin-top: 10px;
`;

const Component = styled.div<{ isShowFixedPanel: boolean }>`
  display: flex;
  flex-direction: column;
  position: fixed;
  bottom: 0;
  right: 0;
  left: 0;
  padding: 12px 20px;
  background: ${(props) => props.theme.white_1};
  border-radius: 24px 24px 0 0;
  box-shadow: ${(props) => props.theme.blackShadow100};
  z-index: 20;
  transition: all 0.3s ease-in-out;

  ${(props) =>
    !props.isShowFixedPanel
      ? css`
          transform: translateY(100%);
        `
      : null}

  & > span {
    font-size: 16px;
    line-height: 19px;
  }
`;

const Title = styled.div`
  font-size: 16px;
  font-weight: 700;
  color: ${(props) => props.theme.black};
`;
